import { useState } from "react";
import Reveal from "./Reveal";
import { faqItems } from "@/config/professional";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="duvidas" className="bg-background-50 py-16 md:py-28">
      <div className="mx-auto max-w-3xl px-4 md:px-6 lg:px-8">
        <div className="text-center">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary-600">
              Dúvidas frequentes
            </p>
            <h2 className="mt-4 font-heading text-4xl font-semibold leading-[1.1] tracking-tight text-foreground-950 md:text-5xl">
              Perguntas e respostas.
            </h2>
            <p className="mt-5 text-base leading-relaxed text-foreground-600">
              Respostas claras para as dúvidas mais comuns. Este site não
              substitui uma avaliação profissional.
            </p>
          </Reveal>
        </div>

        <div className="mt-12 divide-y divide-background-200 border-y border-background-200">
          {faqItems.map((item, i) => {
            const open = openIndex === i;
            return (
              <Reveal key={item.q} delay={i * 40}>
                <div>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? null : i)}
                    aria-expanded={open}
                    aria-controls={`faq-panel-${i}`}
                    className="flex w-full items-center justify-between gap-6 py-5 text-left"
                  >
                    <span className="font-heading text-lg font-semibold text-foreground-950 md:text-xl">
                      {item.q}
                    </span>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-all duration-300 ${
                        open
                          ? "rotate-180 border-primary-600 bg-primary-600 text-background-50"
                          : "border-background-300 text-foreground-600"
                      }`}
                    >
                      <i className="ri-add-line text-lg" aria-hidden="true"></i>
                    </span>
                  </button>

                  <div
                    id={`faq-panel-${i}`}
                    className={`grid transition-all duration-300 ease-out ${
                      open
                        ? "grid-rows-[1fr] opacity-100"
                        : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="pb-6 pr-10 text-base leading-relaxed text-foreground-600">
                        {item.a}
                      </p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}